export default __webpack_public_path__ + "73ba72d6bafae7c38847d801d562ad92.png";